import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useStores } from '../../stores/Hooks';
import { ValidationStatusComponent } from '../../components/ValidationStatusComponent';
import { InfoClarifyLinkComponent } from './InfoClarifyLinkComponent';

export const InfoPageRightBlock: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.info;

		function Fill()
		{
			store.OrganizationName.setValue("Юридическое лицо 148842");
			store.OrganizationInn.setValue("5252019224");
			store.OrganizationKpp.setValue("525201001");
			store.OrganizationHeadLastName.setValue("АБАСЬКИНА");
			store.OrganizationHeadFirstName.setValue("ДАРЬЯ");
			store.OrganizationHeadSecondName.setValue("АЛЕКСАНДРОВНА");
			store.OrganizationHeadPosition.setValue("Директор");
			store.AgreementCheck.setValue(true);
			store.OrganizationHeadSecondNameExists.setValue(true);
			uiState.register.SelectedServiceCategories.forEach((val) =>
			{
				val.Email.setValue("aksenov@gnivc.ru");
				val.Phone.setValue("+7 (910) 705 90 32");
				val.Web.setValue("https://www.gnivc.ru/");
			});
			window.setTimeout(() => store.Validate(), 100);

		}

		return (
			<div className="form-steps">
				<ValidationStatusComponent />
				<hr />
				{!uiState.IsDisabled &&
					<div className="form-step-info">
						<p className="mb-0">Заполните сведения об операторе ЭДО. Эти данные будут указаны <br /> в заявлении.</p>
						{uiState.FillButtons &&
							<button
								className="btn"
								disabled={uiState.IsDisabled}
								onClick={Fill}
								type="button"
							>Заполнить</button>
						}
					</div>
				}
				<InfoClarifyLinkComponent />
			</div>
		);
	}
)
